import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Vector",
  "use": "icon-Vector-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-Vector\"><path d=\"M512.064 895.936a48 48 0 0 0 48.00000001-48L560.064 311.68l234.24 234.24a48 48 0 0 0 67.84-67.84L512 127.99999999l-350.08 350.08000001a48 48 0 0 0 67.84 67.84L464 311.68l0 536.256a48 48 0 0 0 48 48z\" p-id=\"5488\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol